import { render, staticRenderFns } from "./DettaglioModulistica.vue?vue&type=template&id=513d4076&"
import script from "./DettaglioModulistica.vue?vue&type=script&lang=js&"
export * from "./DettaglioModulistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports